
import ScoreCalculator from './ScoreCalculator.js';
import Deck from './Deck.js';
import Analyzer from './Analyzer.js';
export default class PlayerComputer {
    constructor(cribbage, tablePosition, delay, behavior, difficulty, name, avatar, rank) {
        this.name = name || difficulty;
        this.avatar = avatar || "Avatar";
        this.rank = rank || "";
        this.cribbage = cribbage;
        this.tablePosition = tablePosition || "player2"; //should be table position
        this.delay = delay || 1000;
        this.lastAction = 0;
        this.difficulty = difficulty || "Random";
        this.behavior = behavior || "none";
        this.timer = null;
        this.randomChat = true;
        this.welcomeChat = false;
        //this.showTimer = showTimer || true;

        this.computerAutoActions = ["start", "cut", "select", "confirm", "playCribCard", "confirmCrib", "play", "playAgain", "nextRound"];
        //this.gameAutoActions = ["start", "startround", "endCut", "confirmCrib", "go", "clear", "show", "xnext", "nextShow"];
        this.humanAutoActions = [];
        this.humanFakeAutoActions = ["start", "select", "confirm", "startround", "cut", "endCut", "xplayCribCard", "xconfirmCrib", "play", "go", "clear", "show", "next", "nextRound", "nextShow", "playAgain"];

        //this.turnTriggerActions = ["start", "startround", "cut", "endCut", "playCribCard", "confirmCrib", "play", "go", "clear", "show", "next", "nextRound", "nextShow", "playAgain"];



        // this.autoActions = computerAutoActions;
        // if (behavior === "computer") this.autoActions = computerAutoActions;
        // if (behavior === "human") this.autoActions = humanAutoActions;
        // if (behavior === "test") this.autoActions = humanFakeAutoActions;

        //note: would be nice if it had no event listener, just invoked by the game and/or a last action timestampe to know when to take new action
        this.onActionEventListener = this.onAction.bind(this);
        this.onStateChangeEventListener = this.onStateChange.bind(this);
        //////this.cribbage.event.addListener("onTurn", this.onTurn.bind(this));
        this.cribbage.event.addListener("actionEnded", this.onActionEventListener);
        this.cribbage.event.addListener("stateChange", this.onStateChangeEventListener);

        //this.isThinking = false;
    }
    get autoActions() {
        if (this.behavior === "computer")
            return this.computerAutoActions;
        if (this.behavior === "human")
            return this.humanAutoActions;
        if (this.behavior === "test")
            return this.humanFakeAutoActions;
        if (this.behavior === "none")
            return this.humanAutoActions;
    }
    destroy() {
        clearTimeout(this.timer);
        if (this.cribbage) {
            this.cribbage.event.removeListener("actionEnded", this.onActionEventListener);
            this.cribbage.event.removeListener("stateChange", this.onStateChangeEventListener);
        }
        this.cribbage = null;
    }
    // tick() {
    //     this.lastAction = Math.max(this.cribbage.lastActionTime || 0, this.lastAction || 0);
    //     let gameTime = this.cribbage.getElaspedTime();

    //     let timeElapsed = (gameTime - this.lastAction) * 1000;
    //     if (timeElapsed > this.delay) {
    //         this.doAction();
    //         this.lastAction = gameTime;
    //     }

    // }
    onStateChange(arg) {
        this.startProcessEvent(arg);
        this.doChat();
    }
    onAction(arg) {
        this.startProcessEvent(arg);
    }

    startProcessEvent(arg) {
        if (arg.command === "invalidMove") return;
        if (arg.command === "startPlayTimer") return;

        let actions = this.getActions();
        let hasPlayCommand = actions.length !== 0;

        //reset timer
        clearTimeout(this.timer);
        if (hasPlayCommand && this.delay !== 0) {
            this.timer = setTimeout(() => {
                this.doAction();
            }, this.delay);
        }
    }
    doChat() {
        let cribbage = this.cribbage;
        let randomChat = this.randomChat;
        let welcomeChat = this.welcomeChat;
        let state = this.cribbage.currentState;
        let roundNumber = this.cribbage.roundNumber;
        let tablePosition = this.tablePosition;
        let isComputer = this.difficulty !== "Random" && this.difficulty !== "none";
        let isChatRound = roundNumber % 5 == 0;
        let phrasesRandom = [
            "Hello",
            "Good game",
            "Well played",
            "Had enough?",
            "zzzzz",
            "wp",
            "I got this",
            "Good hand",
            "Impressive",
            "My turn",
            "15s",
            "Not bad",
            "Wow!",
            "Love fives",
            "Time to skunk",
            "Play easy",
            "Be nice",
            "Its real",
            "Bring it on",
            "Go!",
            "Lets go",
            "Nice!",
            "Lucky",
            "Aboveboard",
            "Scoreboard",
            "Hmmmm",
            "Thinking...",
            "...",
            "...",
            "Let's see",
            "OK",
            "I smell a skunk",
            "Good game"
        ];

        //get chat message
        if (isComputer && randomChat) {
            if (state === "startRound") {
                //get smart phrases
                let opponentTablePosition = tablePosition === "player1" ? "player2" : "player1";
                let computerHand = tablePosition === "player1" ? "hand1" : "hand2";
                let opponentHand = opponentTablePosition === "player1" ? "hand1" : "hand2";

                let computerScore = cribbage.matchPoints[tablePosition] || 0;
                let opponentScore = cribbage.matchPoints[opponentTablePosition] || 0;
                let scoreLead = computerScore - opponentScore;

                let roundLogs = cribbage.roundLog || [];
                let points = roundLogs.length > 0 ? roundLogs[roundLogs.length - 1].points || [] : [];

                let handPointsComputer = points.filter(p => p.player == tablePosition && p.pile == "hand")
                    .map(p => p.points)
                    .reduce((total, num) => { return total + num }, 0);
                let handPointsOpponent = points.filter(p => p.player == opponentTablePosition && p.pile == "hand")
                    .map(p => p.points)
                    .reduce((total, num) => { return total + num }, 0);

                let playPointsOpponent = points.filter(p => p.player == opponentTablePosition && p.pile == "play")
                    .map(p => p.points)
                    .reduce((total, num) => { return total + num }, 0);



                let phrases = [""];
                if (computerScore > 60 && Math.abs(scoreLead) <= 6) {
                    phrases.push("Close game");
                    phrases.push("It's real");
                    phrases.push("Game is hard");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                }
                if (scoreLead < -40) {
                    phrases.push("I smell a skunk");
                    phrases.push("Play easy");
                    phrases.push("I got this");
                    phrases.push("Wow!");
                    phrases.push("No skunk");
                    phrases.push("Be nice");
                    phrases.push("...");
                    phrases.push("Thinking...");
                    phrases.push("Let's see");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                }
                if (scoreLead > 40) {
                    phrases.push("I smell a skunk");
                    phrases.push("I got this");
                    phrases.push("Hmmmm");
                    phrases.push("Thinking...");
                    phrases.push("Let's see");
                    phrases.push("Had enough?");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                }

                if (playPointsOpponent > 5) {
                    phrases.push("Well played");
                    phrases.push("Well played");
                    phrases.push("Wow!");
                    phrases.push("Nice!");
                    phrases.push("Nicely Played!");
                    phrases.push("Impressive");
                    phrases.push("OK");
                    phrases.push("Not bad");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                }
                if (handPointsOpponent > 12) {
                    phrases.push("Good hand");
                    phrases.push("Well played");
                    phrases.push("Well played");
                    phrases.push("Wow!");
                    phrases.push("Nice!");
                    phrases.push("Nicely Played!");
                    phrases.push("Impressive");
                    phrases.push("OK");
                    phrases.push("Lucky");
                    phrases.push("Not bad");
                }
                if (computerScore > 110 || opponentScore > 110) {
                    phrases.push("Good game");
                    phrases.push("How about 2 out of 3?");
                    phrases.push("wp");
                    phrases.push("Play again?");
                    phrases.push("Rematch?");
                    phrases.push("😀");
                    phrases.push("Hmmmm");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                    phrases.push("");
                }

                let phrase = phrases[Math.floor(Math.random() * phrases.length)];

                this.cribbage.action("chat", phrase, tablePosition);
            }
            // if (state === "startRound" && isChatRound === true) {
            //     //other random phrases if no smart phrases are found
            //     let phrases = phrasesRandom;
            //     let phrase = phrases[Math.floor(Math.random() * phrases.length)];
            // }
        }
        //get welcom phrase
        let phrasesWelcome = [
            "Hello",
            "Hello",
            "Hello",
            "Hi",
            "I'm ready",
            "Good game",
            "",
            "",
            "",
            "",
            "",
        ];
        let phraseWelcome = phrasesWelcome[Math.floor(Math.random() * phrasesWelcome.length)];
        if (welcomeChat) {
            if (state === "cut" && phraseWelcome !== "" && roundNumber == 1) {
                this.cribbage.action("chat", phraseWelcome, tablePosition);
            }
        }

        // if (difficulty === "InsaneMonkey") 
        // if (difficulty === "CrazyNinja") 
        // if (difficulty === "Hard") 
        // if (difficulty === "Medium") 
        // if (difficulty === "Easy") 
    }
    getActions() {
        let actions = this.cribbage.getActions(this.tablePosition);

        //filter out command the computer should not use
        actions = actions.filter((action) => {
            if (!this.autoActions) return false;
            var autoActionExist = this.autoActions.includes(action.command);
            if (autoActionExist === true)
                return true;
            else
                return false;
        });
        return actions;
    }
    doAction() {
        if (!this.cribbage) return;
        let state = this.cribbage.currentState;
        let isDealer = this.cribbage.dealer === this.tablePosition;
        let actions = this.getActions();
        if (actions.length > 0) {
            let hasPlayCommand = actions.some(action => action.command === "play");
            let hasSelectCommand = actions.some(action => action.command === "select");

            if (this.difficulty === "Random") {
                //random move
                let action = actions[Math.floor(Math.random() * actions.length)];
                this.cribbage.action(action.command, action.value, this.tablePosition);
                return true
            }
            if (this.cribbage.currentState === "crib" && hasSelectCommand) {

                this.playCribCards(isDealer);
                return true;
            }

            if (this.cribbage.currentState === "play" && hasPlayCommand) {
                let card = this.getPeggingCard();
                if (card) {
                    this.cribbage.action("play", card.id, this.tablePosition);
                    return true;
                }
            }
            if (this.cribbage.currentState === state) {
                //random move
                let action = actions[Math.floor(Math.random() * actions.length)];
                this.cribbage.action(action.command, action.value, this.tablePosition);
                return true
            }
            ////check the same state is still up
            //if (state !== this.cribbage.currentState) return "done";
        }
        return false;
    }
    playCribCards(isDealer) {
        let handName = this.tablePosition === "player1" ? "hand1" : "hand2";
        let handCards = this.cribbage.getPile(handName);
        let cardCombo = this.findBestHand(handCards, this.difficulty, isDealer);
        let cardsToPlay = this.subractCardArrayFromCardArray(handCards, cardCombo);

        //play both cards not in combo 
        for (let i = 0; i < cardsToPlay.length; i++) {
            let card = cardsToPlay[i];
            this.cribbage.action("select", card.id, this.tablePosition);
        }
        this.cribbage.action("confirm", null, this.tablePosition);
    }
    getPeggingCard() {
        let difficulty = this.difficulty;
        let handName = this.tablePosition === "player1" ? "hand1" : "hand2";
        let handNameOpponent = this.tablePosition === "player2" ? "hand1" : "hand2";
        let handCards = this.cribbage.getPile(handName);
        let handCardsOpponent = this.cribbage.getPile(handNameOpponent);
        let handCardsCountOpponent = handCardsOpponent.length;
        let playCards = this.cribbage.getPile("play");
        let options = this.findAllPossbilePeggingOptions(handCards, playCards);

        //if no options return false
        if (options.length === 0) return false;
        let selectedOption = options[0];
        //find card to play based on difficulty
        //todo: if all option are the same use strat, like no 10's or 5's to start 
        //todo: strat for last card
        //todo: or look ahead 2-3 moves

        //sort by highest points 
        options.sort(function (a, b) { return a.points - b.points });

        //Insane Monkey - get 100 percentile avg 


        if (difficulty === "Impossible") {
            options = this.findAllPossbilePeggingOptions_LookAheadPlus(handCards, playCards, handCardsCountOpponent);
            options = this.pegginStrategy(options, playCards);
            options.sort((a, b) => { return a.points - b.points; });
            selectedOption = options[Math.round((options.length - 1) * 1.00)];
        }
        if (difficulty === "InsaneMonkey") {
            options = this.findAllPossbilePeggingOptions_LookAheadPlus(handCards, playCards, handCardsCountOpponent);
            options = this.pegginStrategy(options, playCards);
            options.sort((a, b) => { return a.points - b.points; });
            selectedOption = options[Math.round((options.length - 1) * 1.00)];
        }
        //CrazyNinja - get 90 percentile avg 
        if (difficulty === "CrazyNinja") {
            options = this.findAllPossbilePeggingOptions_LookAhead(handCards, playCards, handCardsCountOpponent);
            options = this.pegginStrategy(options, playCards);
            options.sort((a, b) => { return a.points - b.points; });
            selectedOption = options[Math.round((options.length - 1) * 1.00)];
        }
        //Hard - get 70 percentile avg 
        if (difficulty === "Hard") {
            options = this.pegginStrategy(options, playCards);
            options.sort((a, b) => { return a.points - b.points; });
            selectedOption = options[Math.round((options.length - 1) * 1.00)];
        }
        //Medium - get 50 percentile avg
        if (difficulty === "Medium") {
            options = this.pegginStrategy(options, playCards);
            options.sort((a, b) => { return a.points - b.points; });
            selectedOption = options[Math.round((options.length - 1) * 0.70)];
        }
        //Easy - get 30 percentile avg
        if (difficulty === "Easy") {
            options.sort((a, b) => { return a.points - b.points; });
            selectedOption = options[Math.round((options.length - 1) * 0.50)];
        }
        //easy2 - get lowest avg
        if (difficulty === "Easy2") {
            options.sort((a, b) => { return a.points - b.points; });
            selectedOption = options[Math.round((options.length - 1) * 0.10)];
        }
        if (difficulty === "Random") {
            selectedOption = options[0];
        }

        let card = selectedOption.card;

        //return if can play
        return card;
    }
    pegginStrategy(options, playCards) {
        let newOptions = options.slice();

        //first card
        if (playCards.length === 0) {
            //discourage playing a "5" or "10" first 
            //highest to lowest
            newOptions.sort(function (a, b) { return a.card.value - b.card.value });
            for (let i = 0; i < newOptions.length; i++) {
                let option = newOptions[i];
                //option.points = i; //play highest to lowest
                if (option.card.value === 5) {
                    option.points = option.points - 3;
                }
                // if (option.card.value === 10) {
                //     option.points = option.points - 3;
                // }
            }
        }
        //no point options for turn
        if (playCards.length !== 0) {
            //if all plays are the same, 0 , play highest to lowest
            let cardsCountWith0Points = newOptions.filter(option => option.points === 0).length;
            if (cardsCountWith0Points === newOptions.length) {
                //order by card value...
                newOptions.sort(function (a, b) { return a.card.value - b.card.value });
                for (let i = 0; i < newOptions.length; i++) {
                    let option = newOptions[i];
                    option.points = i;
                }
            }
        }

        return newOptions;
    }
    findAllPossbilePeggingOptions(handCards, pilePlay) {
        let calc = new ScoreCalculator();
        let options = [];

        for (let i = 0; i < handCards.length; i++) {
            let card = handCards[i];

            let peggingTotal = pilePlay.reduce((total, card) => total + card.value, 0);

            //get all playable cards
            if (card.value + peggingTotal > 31) continue;

            let possiblePlayCards = pilePlay.concat([card]);

            //get points for immidiate move
            let pointLogs = calc.scorePeggingPoints(possiblePlayCards);
            let points = pointLogs.reduce((total, pointLog) => total + pointLog.points, 0);

            //save option
            let option = {
                card: card,
                points: points,
                pointsIn2Moves: 0,  //todo: look ahead 2-3 moves based on possible points and possible point opponent gets
            };
            options.push(option)
        }
        //return options, might be none
        return options;
    }
    findAllPossbilePeggingOptions_LookAhead(handCards, pilePlay, opponentCardCountp) {
        let calc = new ScoreCalculator();
        let options = [];
        let cardCountOpponent = opponentCardCountp || handCards.length;

        for (let i = 0; i < handCards.length; i++) {
            let card = handCards[i];

            let peggingTotal = pilePlay.reduce((total, card) => total + card.value, 0);

            //get all playable cards
            if (card.value + peggingTotal > 31) continue;

            let possiblePlayCards = pilePlay.concat([card]);

            //get points for immidiate move
            let pointLogs = calc.scorePeggingPoints(possiblePlayCards);
            let pointsIn1Move = pointLogs.reduce((total, pointLog) => total + pointLog.points, 0);
            let pointPredication = 0;

            //move 2  - opponent
            if (cardCountOpponent > 0) {
                let possibilitiesForOptions = [];
                for (let value = 1; value < 14; value++) {
                    let cardIn2Moves = {
                        number: value,
                        value: Math.min(value, 10),
                        suit: "s",
                        suitValue: 4
                    };
                    let possiblePlayCardsIn2Moves = possiblePlayCards.concat([cardIn2Moves]);
                    let pointLogsIn2Moves = calc.scorePeggingPoints(possiblePlayCardsIn2Moves);
                    let pointsIn2Moves = pointLogsIn2Moves.reduce((total, pointLog) => total + pointLog.points, 0);


                    //get points for posible 3rd moves (2nd player's move)
                    let move3HandCards = handCards.filter(c => c.id !== card.id);
                    let pointsIn3Moves = 0;
                    let cardIn3Moves = null;
                    for (let j = 0; j < move3HandCards.length; j++) {
                        let card3 = move3HandCards[j];

                        //get all playable cards
                        if (card3.value + peggingTotal > 31) continue;

                        let possiblePlayCardsIn3Moves = possiblePlayCardsIn2Moves.concat([card3]);

                        //get points for  move
                        let pointLogsIn3Moves = calc.scorePeggingPoints(possiblePlayCardsIn3Moves);
                        let pointsFor3rdMove = pointLogsIn3Moves.reduce((total, pointLog) => total + pointLog.points, 0);

                        if (pointsFor3rdMove > pointsIn3Moves) {
                            pointsIn3Moves = pointsFor3rdMove;
                            cardIn3Moves = card3;
                        }
                    }
                    let totalPoints = (pointsIn1Move - pointsIn2Moves) + pointsIn3Moves;
                    let possibility = {
                        card: card,
                        pointsIn1Move: pointsIn1Move,
                        cardIn2Moves: cardIn2Moves,
                        pointsIn2Moves: pointsIn2Moves,
                        cardIn3Moves: cardIn3Moves,
                        pointsIn3Moves: pointsIn3Moves,
                        totalPoints: totalPoints
                    };
                    possibilitiesForOptions.push(possibility);

                }

                //chance has card and will use based on number of cards in hand and asuming they will play the best card not looking ahead
                let playHighestCardValueProbablity = this.getPlayHighestCardValueProbablity(cardCountOpponent);
                possibilitiesForOptions.sort(function (a, b) { return b.pointsIn2Moves - a.pointsIn2Moves });
                //possibilitiesForOptions.sort(function (a, b) { return a.totalPoints - b.totalPoints });
                for (let rank = 1; rank < 14; rank++) {
                    let option = possibilitiesForOptions[rank - 1];
                    option.probablity = playHighestCardValueProbablity[rank];
                    option.weightedPoints = option.probablity * option.totalPoints;
                }

                //get avg points based on : chance has card and will use based on number of cards in hand and asuming they will play the best card not looking ahead
                let weightedSum = possibilitiesForOptions.reduce((total, poss) => total + poss.weightedPoints, 0);
                pointPredication = weightedSum;
            }

            //save option
            let option = {
                card: card,
                points: pointPredication,
                pointsIn1Move: pointsIn1Move
                //todo: add 20%,50%,90% possible points
            };
            options.push(option)
        }
        //return options, might be none
        return options;
    }
    findAllPossbilePeggingOptions_LookAheadPlus(handCards, pilePlay, opponentCardCountp) {
        let calc = new ScoreCalculator();
        let options = [];
        let cardCountOpponent = opponentCardCountp || handCards.length;

        for (let i = 0; i < handCards.length; i++) {
            let card = handCards[i];

            let peggingTotal = pilePlay.reduce((total, card) => total + card.value, 0);

            //get all playable cards
            if (card.value + peggingTotal > 31) continue;

            let possiblePlayCards = pilePlay.concat([card]);

            //get points for immidiate move
            let pointLogs = calc.scorePeggingPoints(possiblePlayCards);
            let pointsIn1Move = pointLogs.reduce((total, pointLog) => total + pointLog.points, 0);
            let pointPredication = 0;

            //move 2  - opponent
            if (cardCountOpponent > 0) {
                let possibilitiesForOptions = [];
                for (let value = 1; value < 14; value++) {
                    let cardIn2Moves = {
                        number: value,
                        value: Math.min(value, 10),
                        suit: "s",
                        suitValue: 4
                    };
                    let possiblePlayCardsIn2Moves = possiblePlayCards.concat([cardIn2Moves]);
                    let pointLogsIn2Moves = calc.scorePeggingPoints(possiblePlayCardsIn2Moves);
                    let pointsIn2Moves = pointLogsIn2Moves.reduce((total, pointLog) => total + pointLog.points, 0);


                    //get points for posible 3rd moves (2nd player's move)
                    let move3HandCards = handCards.filter(c => c.id !== card.id);
                    let pointsIn3Moves = 0;
                    let cardIn3Moves = null;
                    for (let j = 0; j < move3HandCards.length; j++) {
                        let card3 = move3HandCards[j];

                        //get all playable cards
                        if (card3.value + peggingTotal > 31) continue;

                        let possiblePlayCardsIn3Moves = possiblePlayCardsIn2Moves.concat([card3]);

                        //get points for  move
                        let pointLogsIn3Moves = calc.scorePeggingPoints(possiblePlayCardsIn3Moves);
                        let pointsFor3rdMove = pointLogsIn3Moves.reduce((total, pointLog) => total + pointLog.points, 0);

                        if (pointsFor3rdMove > pointsIn3Moves) {
                            pointsIn3Moves = pointsFor3rdMove;
                            cardIn3Moves = card3;
                        }

                        // //move 4 - opponent 2nd opponent's
                        // for (let m = 0; possibleCardsForOpponent.length < m;m++) {
                        //     let cardIn4Moves = possibleCardsForOpponent[m];
                        //     let possiblePlayCardsIn4Moves = possiblePlayCards.concat([cardIn4Moves]);
                        //     let pointLogsIn4Moves = calc.scorePeggingPoints(possiblePlayCardsIn4Moves);
                        //     let pointsIn4Moves = pointLogsIn2Moves.reduce((total, pointLog) => total + pointLog.points, 0);
                        // }


                        // //get points for posible 4rd moves (2nd player's move)
                        // let move5HandCards = move3HandCards.filter(c => c.id !== card3.id);
                        // let pointsIn5Moves = 0;
                        // let cardIn5Moves = null;
                        // for (let j = 0; j < move5HandCards.length; j++) {
                        //     let card5 = move5HandCards[j];

                        //     //get all playable cards
                        //     if (card5.value + peggingTotal > 31) continue;

                        //     let possiblePlayCardsIn3Moves = possiblePlayCardsIn5Moves.concat([card5]);

                        //     //get points for  move
                        //     let pointLogsIn5Moves = calc.scorePeggingPoints(possiblePlayCardsIn5Moves);
                        //     let pointsFor5rdMove = pointLogsIn3Moves.reduce((total, pointLog) => total + pointLog.points, 0);

                        //     if (pointsFor5rdMove > pointsIn5Moves) {
                        //         pointsIn5Moves = pointsFor5rdMove;
                        //         cardIn5Moves = card5;
                        //     }
                        //}

                    }
                    let totalPoints = (pointsIn1Move - pointsIn2Moves) + pointsIn3Moves;

                    let possibility = {
                        card: card,
                        pointsIn1Move: pointsIn1Move,
                        cardIn2Moves: cardIn2Moves,
                        pointsIn2Moves: pointsIn2Moves,
                        cardIn3Moves: cardIn3Moves,
                        pointsIn3Moves: pointsIn3Moves,
                        totalPoints: totalPoints
                    };
                    possibilitiesForOptions.push(possibility);

                }

                //chance has card and will use based on number of cards in hand and asuming they will play the best card
                //todo: looking ahead 1 move
                let playHighestCardValueProbablity = this.getPlayHighestCardValueProbablity(cardCountOpponent);
                possibilitiesForOptions.sort(function (a, b) { return b.pointsIn2Moves - a.pointsIn2Moves });

                for (let rank = 1; rank < 14; rank++) {
                    let option = possibilitiesForOptions[rank - 1];
                    option.probablity = playHighestCardValueProbablity[rank];
                    option.weightedPoints = option.probablity * (option.pointsIn3Moves - option.pointsIn2Moves);
                }

                //get avg points based on : chance has card and will use based on number of cards in hand and asuming they will play the best card not looking ahead
                let weightedSum = possibilitiesForOptions.reduce((total, poss) => total + poss.weightedPoints, 0);
                pointPredication = weightedSum;
            }

            //save option
            let option = {
                card: card,
                points: pointsIn1Move + pointPredication,
                pointsIn1Move: pointsIn1Move,
                pointPredication: pointPredication
                //todo: add 20%,50%,90% possible points
            };
            options.push(option)
        }
        //return options, might be none
        return options;
    }
    getPlayHighestCardValueProbablity(cardCount) {
        //todo: pass in rank to get value for rather than array.  It would need to solve the formula for x(rank)
        //https://math.stackexchange.com/questions/85849/calculating-the-probability-that-at-least-one-of-a-series-of-events-will-happen
        if (cardCount == 0) return [];
        let rankPorbablitys = [];
        let lastPercentage = 0;
        for (let rank = 1; rank < 14; rank++) {
            let probablityNotFound = (13 - rank) / 13;
            let probablityWithAtleastNValueCardsInHand = 1 - Math.pow(probablityNotFound, cardCount);
            let probablityOfSelectingValue = probablityWithAtleastNValueCardsInHand - lastPercentage;
            rankPorbablitys[rank] = probablityOfSelectingValue;
            lastPercentage = probablityWithAtleastNValueCardsInHand;
        }
        return rankPorbablitys;
    }
    peggingTotal() {
        let pilePlay = this.cribbage.getPile("play");
        let playTotal = this.cardsTotal(pilePlay);
        return playTotal;
    }
    cardsTotal(cards) {
        var total = cards.reduce(function (sum, card) {
            return sum + card.value;
        }, 0);
        return total;
    }
    findBestHand(handCards, difficulty, isDealer) {
        let analyzer = new Analyzer();
        //console.log("findBestHand");
        // let options = this.findAllPossbileHandsWithScores(handCards);
        let options = [];

        let selectedOption = options[0]; //default option


        //note: could have a computer that picks the best possible hand even if high risk

        //get best option based on type of computer and factor in crib options

        // vs CrazyNinja @  0.85 and basic crib
        // win_rate_Impossible:'0.16' @  1.00 and enhanced crib
        // win_rate_InsaneMonkey:'0.38' @  0.90 and enhanced crib
        // win_rate_CrazyNinja:'0.50' @  0.85 and basic crib
        // win_rate_Hard:'0.64' @ 0.80 and and basic crib
        // win_rate_Medium:'0.80' @  0.80 and no crib
        // win_rate_Easy:'0.95' @ 0.65 and no crib

        //Insane Monkey - get 100 percentile avg 
        if (difficulty === "Impossible") {
            options = analyzer.findAllPossbileHandsWithScores_FactorInCrib(handCards, isDealer, true);
            options.sort((a, b) => { return a.avgScore - b.avgScore; });
            selectedOption = options[Math.round((options.length - 1) * 1.00)];
        }
        if (difficulty === "InsaneMonkey") {
            options = analyzer.findAllPossbileHandsWithScores_FactorInCrib(handCards, isDealer, true);
            options.sort((a, b) => { return a.avgScore - b.avgScore; });
            //get a random percentile between 90% and 100%
            let percentileHard = (Math.floor(Math.random() * 11) + 90) / 100;
            selectedOption = options[Math.round((options.length - 1) * percentileHard)];
        }
        //CrazyNinja - get 100 percentile avg 
        if (difficulty === "CrazyNinja") {
            options = analyzer.findAllPossbileHandsWithScores_FactorInCrib(handCards, isDealer, false);
            options.sort((a, b) => { return a.avgScore - b.avgScore; });
            selectedOption = options[Math.round((options.length - 1) * 0.85)];
        }
        //Hard - get 70 percentile avg 
        if (difficulty === "Hard") {
            options = analyzer.findAllPossbileHandsWithScores_FactorInCrib(handCards, isDealer, false);
            options.sort((a, b) => { return a.avgScore - b.avgScore; });
            selectedOption = options[Math.round((options.length - 1) * 0.80)];
        }
        //Medium - get 50 percentile avg
        if (difficulty === "Medium") {
            options = analyzer.findAllPossbileHandsWithScores(handCards);
            options.sort((a, b) => { return a.avgScore - b.avgScore; });
            selectedOption = options[Math.round((options.length - 1) * 0.80)];
        }
        //Easy - get 30 percentile avg
        if (difficulty === "Easy") {
            options = analyzer.findAllPossbileHandsWithScores(handCards);
            options.sort((a, b) => { return a.avgScore - b.avgScore; });
            selectedOption = options[Math.round((options.length - 1) * 0.65)];
        }
        //easy2 - get lowest avg
        if (difficulty === "Easy2") {
            options = analyzer.findAllPossbileHandsWithScores(handCards);
            options.sort((a, b) => { return a.avgScore - b.avgScore; });
            selectedOption = options[Math.round((options.length - 1) * 0.10)];
        }
        if (difficulty === "Random") {
            options = analyzer.findAllPossbileHandsWithScores(handCards);
            selectedOption = options[0];
        }

        if (!selectedOption) {
            console.error("Bug - selectedOption should not be null");
        }

        //console.log(JSON.stringify(this.difficulty + ":" + "avgScore: " + selectedOption.avgScore));
        //return best card combo
        let cardCombo = selectedOption.cards;
        return cardCombo;
    }
    subractCardArrayFromCardArray(cardArray1, cardArray2) {
        let outputCards = [];
        //get all unknown cards (not in hand)
        for (let i = 0; i < cardArray1.length; i++) {
            let card = cardArray1[i];
            //if not in hand then add to output array
            var cards = cardArray2.filter(function (c) {
                return c.id === card.id;
            });
            if (cards.length === 0) {
                outputCards.push(card);
            }
        }
        return outputCards;
    }

}